// src/modules/app-views/_apps/appmulti/receivables/pages/Init/actions/menuButton.js
import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

const receivablesInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [{ ...dropdownParameters, onClick: () => {} }],
  };
};

export default receivablesInitMenuButton;
